module.exports = __webpack_public_path__ + "img/sand-rock-medium-06.860f8b91.png";